import {
	REQUEST_STATS_LOADING,
	REQUEST_STATS_HOURLY_GET,
	REQUEST_STATS_HOURLY_ERROR,
	REQUEST_STATS_DAILY_GET,
	REQUEST_STATS_DAILY_ERROR,
	REQUEST_STATS_CURRENT_GET,
	REQUEST_STATS_CURRENT_ERROR,
	REQUEST_STATS_PERFORMANCE_GET,
	REQUEST_STATS_PERFORMANCE_ERROR,
	REQUEST_STATS_PEAK_GET,
	REQUEST_STATS_PEAK_ERROR,
	REQUEST_STATS_ANOMALIES_GET,
	REQUEST_STATS_ANOMALIES_ERROR,
	REQUEST_STATS_SUMMARY_GET,
	REQUEST_STATS_SUMMARY_ERROR,
	REQUEST_STATS_ROUTE_GET,
	REQUEST_STATS_ROUTE_ERROR,
	REQUEST_STATS_THROUGHPUT_GET,
	REQUEST_STATS_THROUGHPUT_ERROR,
	REQUEST_STATS_PERCENTILES_GET,
	REQUEST_STATS_PERCENTILES_ERROR,
	REQUEST_STATS_BATCHES_GET,
	REQUEST_STATS_BATCHES_ERROR,
	REQUEST_STATS_HEALTH_GET,
	REQUEST_STATS_HEALTH_ERROR
} from '../actions/types';

const initialState = {
	request_stats_loading: false,
	request_stats_hourly: { data: [] },
	request_stats_daily: { data: [] },
	request_stats_current: { data: {} },
	request_stats_performance: { data: {} },
	request_stats_peak: { data: {} },
	request_stats_anomalies: { data: {} },
	request_stats_summary: { data: {} },
	request_stats_route: { data: {} },
	request_stats_throughput: [],
	request_stats_percentiles: [],
	request_stats_batches: {},
	request_stats_health: [],
	request_stats_errors: {}
}

export default function requestStatsReducer(state = initialState, action){
	switch(action.type){
		case REQUEST_STATS_LOADING:
			return {
				...state,
				request_stats_loading: action.payload
			}
		case REQUEST_STATS_HOURLY_GET:
			delete state.request_stats_errors.request_stats_hourly
			return {
				...state,
				request_stats_hourly: action.payload
			}
		case REQUEST_STATS_DAILY_GET:
			delete state.request_stats_errors.request_stats_daily
			return {
				...state,
				request_stats_daily: action.payload
			}
		case REQUEST_STATS_CURRENT_GET:
			delete state.request_stats_errors.request_stats_current
			return {
				...state,
				request_stats_current: action.payload
			}
		case REQUEST_STATS_PERFORMANCE_GET:
			delete state.request_stats_errors.request_stats_performance
			return {
				...state,
				request_stats_performance: action.payload
			}
		case REQUEST_STATS_PEAK_GET:
			delete state.request_stats_errors.request_stats_peak
			return {
				...state,
				request_stats_peak: action.payload
			}
		case REQUEST_STATS_ANOMALIES_GET:
			delete state.request_stats_errors.request_stats_anomalies
			return {
				...state,
				request_stats_anomalies: action.payload
			}
		case REQUEST_STATS_SUMMARY_GET:
			delete state.request_stats_errors.request_stats_summary
			return {
				...state,
				request_stats_summary: action.payload
			}
		case REQUEST_STATS_ROUTE_GET:
			delete state.request_stats_errors.request_stats_route
			return {
				...state,
				request_stats_route: action.payload
			}
		case REQUEST_STATS_THROUGHPUT_GET:
			delete state.request_stats_errors.request_stats_throughput
			return {
				...state,
				request_stats_throughput: action.payload
			}
		case REQUEST_STATS_PERCENTILES_GET:
			delete state.request_stats_errors.request_stats_percentiles
			return {
				...state,
				request_stats_percentiles: action.payload
			}
		case REQUEST_STATS_BATCHES_GET:
			delete state.request_stats_errors.request_stats_batches
			return {
				...state,
				request_stats_batches: action.payload
			}
		case REQUEST_STATS_HEALTH_GET:
			delete state.request_stats_errors.request_stats_health
			return {
				...state,
				request_stats_health: action.payload
			}
		case REQUEST_STATS_HOURLY_ERROR:
		case REQUEST_STATS_DAILY_ERROR:
		case REQUEST_STATS_CURRENT_ERROR:
		case REQUEST_STATS_PERFORMANCE_ERROR:
		case REQUEST_STATS_PEAK_ERROR:
		case REQUEST_STATS_ANOMALIES_ERROR:
		case REQUEST_STATS_SUMMARY_ERROR:
		case REQUEST_STATS_ROUTE_ERROR:
		case REQUEST_STATS_THROUGHPUT_ERROR:
		case REQUEST_STATS_PERCENTILES_ERROR:
		case REQUEST_STATS_BATCHES_ERROR:
		case REQUEST_STATS_HEALTH_ERROR:
			return {
				...state,
				request_stats_errors: {
					...state.request_stats_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
